


































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { addDays, subMonths, format, parse } from "date-fns";

@Component
export default class SearchDateRange extends Vue {
  @Prop({}) filter!: any;
  @Prop({}) model!: any;
  @Prop({ default: "" }) customLabel!: string;
  @Prop({
    default: () => ({ from: "report_from", to: "report_to" })
  })
  customPlaceholders!: any;

  pickerValue: Array<Date | null> | null = null;

  pickerOptions: any = {};

  get label() {
    if (this.customLabel) {
      return this.customLabel;
    }
    return this.filter ? this.$t(this.filter.field) : "";
  }

  created() {
    this.initPickerOptions();
    this.initDefaultRange();
    this.emitModelUpdate();
  }

  initPickerOptions() {
    if (
      this.filter &&
      this.filter.typeSpec &&
      this.filter.typeSpec.includes("+0d")
    ) {
      this.pickerOptions = {
        disabledDate(time: Date) {
          return time.getTime() > Date.now();
        }
      };
    }
  }

  initDefaultRange() {
    const today = new Date();
    let start: Date | null = null;
    let end: Date | null = null;

    if (this.filter && this.filter.defaultValue) {
      const def = this.filter.defaultValue;

      if (def === "lastMonth") {
        start = addDays(subMonths(today, 1), 1);
        end = today;
      } else if (def === "emptyDate") {
        start = null;
        end = null;
      } else {
        try {
          start = parse(def, "yyyy-MM-dd", new Date());
          end = parse(def, "yyyy-MM-dd", new Date());
        } catch {
          start = null;
          end = null;
        }
      }
    }

    if (this.model && (this.model.dateStart || this.model.dateEnd)) {
      start = this.model.dateStart ? new Date(this.model.dateStart) : null;
      end = this.model.dateEnd ? new Date(this.model.dateEnd) : null;
    }

    if (start && end) {
      this.pickerValue = [start, end];
    } else {
      this.pickerValue = null;
    }
  }

  handleChange(val: Array<Date> | null) {
    this.pickerValue = val;

    this.emitModelUpdate();

    this.$emit("dateChanged");
  }

  emitModelUpdate() {
    let start: Date | null = null;
    let end: Date | null = null;

    if (this.pickerValue && this.pickerValue.length === 2) {
      start = this.pickerValue[0] || null;
      end = this.pickerValue[1] || null;
    }

    this.$emit("update:model", {
      dateStart: start ? format(start, "yyyy-MM-dd") : null,
      dateEnd: end ? format(end, "yyyy-MM-dd") : null
    });
  }
}
